import { useStore } from "@stores";
import { useEffect } from "react";

export const useBlogPosts = (tag?: string, categoryKey?: string) => {
  const { blogStore } = useStore();
  const { posts, loading, hasMore, skipCount } = blogStore;

  useEffect(() => {
    blogStore.getAll(tag, categoryKey);
    return () => blogStore.clear();
  }, [blogStore, tag, categoryKey, skipCount]);

  return {
    posts,
    loading,
    hasMore,
    loadMore: blogStore.loadMore,
  };
};
